import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({
  scale,
  verticalOffset = 0,
  gradientStop1 = '#53533F',
  gradientStop2 = '#010101',
}) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`
  const transformOrigin = '23.97 8.67'

  return (
    <g transform={`scale(${scale},${scale}) translate(0,${verticalOffset})`} transform-origin={transformOrigin}>
      <path
        d="M10.9199 14.55C3.8999 14.55 3.6799 8.80994 4.0399 5.51994C4.4099 2.22994 9.12995 2.40995 11.8399 2.40995C16.0899 2.40995 20.4299 3.24999 20.6499 6.31999C20.8699 9.38999 17.9399 14.55 10.9199 14.55Z"
        fill={`url(#${randomGradientId1})`}
      />
      <path
        d="M27.24 6.31999C27.46 3.24999 31.79 2.40995 36.05 2.40995C38.76 2.40995 43.48 2.22994 43.85 5.51994C44.22 8.80994 44 14.55 36.97 14.55C29.94 14.55 27.02 9.38999 27.24 6.31999Z"
        fill={`url(#${randomGradientId2})`}
      />
      <path
        d="M27.0101 2.3699C25.3201 2.7899 24.0501 3.00994 23.9601 3.02994C23.8601 3.00994 22.6001 2.7999 20.9101 2.3699C19.1501 1.9299 12.4601 -0.0700073 0.390137 1.70999L0.610107 4.77994C0.610107 4.77994 2.37015 5.32999 2.59015 7.07999C2.81015 8.83999 2.7001 15.42 10.6001 15.42C18.5001 15.42 20.4001 11.1199 21.3501 9.37991C22.3601 7.54991 22.5601 5.55995 23.9701 5.53995C25.3801 5.55995 25.5701 7.54991 26.5901 9.37991C27.5501 11.1099 29.4401 15.42 37.3401 15.42C45.2402 15.42 45.1301 8.83999 45.3501 7.07999C45.5701 5.31999 47.3301 4.77994 47.3301 4.77994L47.5501 1.70999C35.4601 -0.0700073 28.7701 1.9299 27.0101 2.3699ZM10.8501 14.5099C3.8301 14.5099 3.61009 8.77001 3.97009 5.48001C4.34009 2.19001 9.06014 2.3699 11.7701 2.3699C16.0201 2.3699 20.3601 3.20994 20.5801 6.27994C20.8001 9.35994 17.8701 14.5099 10.8501 14.5099ZM37.0701 14.5099C30.0501 14.5099 27.1201 9.34994 27.3401 6.27994C27.5601 3.20994 31.8901 2.3699 36.1501 2.3699C38.8601 2.3699 43.5801 2.19001 43.9501 5.48001C44.3201 8.77001 44.0901 14.5099 37.0701 14.5099Z"
        fill="#010101"
        stroke="#010101"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        d="M2.24023 3.84998H1.95026C1.69026 3.84998 1.47021 3.63987 1.47021 3.36987C1.47021 3.10987 1.68026 2.88989 1.95026 2.88989H2.24023C2.50023 2.88989 2.72021 3.09987 2.72021 3.36987C2.72021 3.63987 2.50023 3.84998 2.24023 3.84998Z"
        fill="white"
      />
      <path
        d="M45.6802 3.84998H45.9702C46.2302 3.84998 46.4502 3.63987 46.4502 3.36987C46.4502 3.10987 46.2402 2.88989 45.9702 2.88989H45.6802C45.4202 2.88989 45.2002 3.09987 45.2002 3.36987C45.2002 3.63987 45.4102 3.84998 45.6802 3.84998Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="12.3008"
          y1="1.76105"
          x2="12.3008"
          y2="14.1474"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradientStop1} />
          <stop offset="1" stopColor={gradientStop2} />
        </linearGradient>
        <linearGradient
          id={randomGradientId2}
          x1="35.5849"
          y1="1.76105"
          x2="35.5849"
          y2="14.1474"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradientStop1} />
          <stop offset="1" stopColor={gradientStop2} />
        </linearGradient>
      </defs>
    </g>
  )
}
